
import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { CycleData, HormoneType, hormoneColors } from '@/utils/cycle-tracking';
import { formatTooltipLabel } from '../hormone-chart/formatUtils';
import { prepareChartData } from '../hormone-chart/chartDataUtils';
import { format } from 'date-fns';
import { ScrollArea, ScrollBar } from '@/components/ui/scroll-area';

interface HormoneTableViewProps {
  cycleData: CycleData;
  selectedHormones: HormoneType[];
}

export const HormoneTableView: React.FC<HormoneTableViewProps> = ({ cycleData, selectedHormones }) => {
  const chartData = prepareChartData(cycleData);
  
  return (
    <ScrollArea className="w-full h-[350px]">
      <div className="min-w-[700px]">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-[100px]">Date</TableHead>
              <TableHead className="w-[100px]">Cycle Day</TableHead>
              <TableHead className="w-[120px]">Phase</TableHead>
              {selectedHormones.map(hormone => (
                <TableHead 
                  key={hormone}
                  style={{ color: hormoneColors[hormone] }}
                  className="w-[120px] font-medium"
                >
                  {hormone.charAt(0).toUpperCase() + hormone.slice(1)}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {chartData.map((day, idx) => (
              <TableRow key={idx}>
                <TableCell className="font-medium">
                  {format(day.absoluteDate, 'MMM d')}
                </TableCell>
                <TableCell>Day {day.day}</TableCell>
                <TableCell className="capitalize">{day.phase}</TableCell>
                {selectedHormones.map(hormone => (
                  <TableCell key={hormone}>
                    {day[hormone] !== undefined ? `${Math.round(day[hormone])}%` : '-'}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <ScrollBar orientation="horizontal" className="h-2" />
    </ScrollArea>
  );
};
